module.exports = __webpack_public_path__ + "static/GJ Logo-e2b4e68302d05b27996d64c93140c6d8.png";